import React, { useRef } from 'react'
import {
  createStyleSheet,
  Divider,
  IconButton,
  Text,
  useStyleSheet,
  View
} from '@gopeerproject/ui-kit'

import { withRenderModal } from '@hocs'

import Settings from '../Settings'

const SettingsModal = ({ closeModal }) => {
  const styles = useStyleSheet(getStyles)
  const overlay = useRef()
  return (
    <View
      style={styles.overlay}
      ref={overlay}
      onClick={(e) => {
        if (e.target === overlay.current) closeModal()
      }}
    >
      <View style={styles.container}>
        <View style={styles.header}>
          <Text type='heading' size='h6'>
            Settings
          </Text>
          <IconButton
            type='tertiary'
            size='sm'
            accent='neutral'
            value='dismiss'
            onPress={closeModal}
          />
        </View>
        <Divider style={styles.divider} />
        <Settings />
      </View>
    </View>
  )
}

const getStyles = createStyleSheet(({ size, color }) => ({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.42)'
  },
  container: { backgroundColor: color.bg.v2, borderRadius: size.G },
  header: {
    paddingVertical: size.G,
    paddingHorizontal: size.K,
    flexDirection: 'row',
    gap: size.C,
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  divider: { backgroundColor: color.invert2.p4, height: 1 }
}))

export default withRenderModal('settings')(SettingsModal)
